/**
 * Stable pastel avatar colour per sender — the same address always gets the
 * same colour, the way Outlook tints its initials avatars. Shared by the
 * message list and the reading pane so a sender looks the same in both.
 */
const PALETTE = [
    "bg-blue-100 text-blue-700 dark:bg-blue-900/60 dark:text-blue-300",
    "bg-violet-100 text-violet-700 dark:bg-violet-900/60 dark:text-violet-300",
    "bg-pink-100 text-pink-700 dark:bg-pink-900/60 dark:text-pink-300",
    "bg-teal-100 text-teal-700 dark:bg-teal-900/60 dark:text-teal-300",
    "bg-amber-100 text-amber-800 dark:bg-amber-900/60 dark:text-amber-300",
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/60 dark:text-emerald-300",
    "bg-rose-100 text-rose-700 dark:bg-rose-900/60 dark:text-rose-300",
    "bg-sky-100 text-sky-700 dark:bg-sky-900/60 dark:text-sky-300",
    "bg-orange-100 text-orange-700 dark:bg-orange-900/60 dark:text-orange-300",
    "bg-slate-200 text-slate-700 dark:bg-slate-700/60 dark:text-slate-200"
];

export function avatarColorClass(email: string): string {
    let h = 0;
    for (let i = 0; i < email.length; i++) h = (h * 31 + email.charCodeAt(i)) % PALETTE.length;
    return PALETTE[h] ?? PALETTE[0]!;
}
